import React from "react";
import { Routes, Route } from "react-router-dom";
import ContextProvider from "context/ContextProvider";
import Header from "Layout/Header/Header";
import Footer from "Layout/Footer/Footer";

import NotFound from "Pages/NotFound";
import Home from "Pages/Home/Home";
// import Books from "Pages/Books/Books";
// import BookDetailes from "Pages/Books/BookDetailes/BookDetailes";
// import Products from "Pages/Products/Products";
// import ProductDetailed from "Pages/Products/ProductDetailed";
import Courses from "Pages/Courses/Courses";
import CourseDetailes from "Pages/Courses/CourseDetailes/CourseDetailes";
import Cart from "Pages/Cart/Cart";
import AboutUsPage from "Pages/About/AboutUsPage";
// auth
import Login from "Pages/Auth/Login";
import Register from "Pages/Auth/Register";
import ForgotPassword from "Pages/Auth/ForgotPassword";
import VerifyForgotPassword from "Pages/Auth/VerifyForgotPassword";
import VerifyEmail from "Pages/Auth/VerifyEmail";

// my account
import MyAccount from "Pages/MyAccount/MyAccount";

console.log("empty");
const App = () => {
  return (
    <ContextProvider>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          {/** Hidden temporarily: Books & Products routes */}
          {/** <Route path="/books" element={<Books />} /> */}
          {/** <Route path="/book/:slug" element={<BookDetailes />} /> */}
          {/** <Route path="/products" element={<Products />} /> */}
          {/** <Route path="/product/:slug" element={<ProductDetailed />} /> */}
          <Route path="/courses/:slug" element={<Courses />} />
          <Route path="/course-detailes/:slug" element={<CourseDetailes />} />
          <Route path="*" element={<NotFound />} />

          {/* auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/verify-forgot-password"
            element={<VerifyForgotPassword />}
          />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* my account */}
          <Route path="/my-account" element={<MyAccount />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/about" element={<AboutUsPage />} />
        </Routes>
        <Footer />
      </div>
    </ContextProvider>
  );
};

export default App;
